import React, { Component, Fragment } from 'react';
import { observer } from 'mobx-react';

import FanzoneHeader from '../../assets/FanZonePage/Fanzone_tagline.png';
import FanzoneHeaderOutline from '../../assets/FanZonePage/rectangle-outline.png';
import AnchorStore from '../../store/AnchorStore';

import styles from './FanZone.module.css';
import AnchorFanzone from './AnchorFanzone';


class FanZone extends Component {

  async componentDidMount() {
    document.title = 'Fan Zones | Naked News';
    const { anchorsWithFanzone } = AnchorStore;
    if (!anchorsWithFanzone?.length) {
      await AnchorStore.setAnchorsWithFanzone();
    }
  }

  render() {
    const { anchorsWithFanzone } = AnchorStore;

    return (
      <Fragment>
        <div className={styles.headerWrapper}>
          <div className={styles.borderWrapper}>
            <img alt="FANZONE" className={styles.fanzoneHeaderOutline} src={FanzoneHeaderOutline} />
            <img alt="FANZONE" className={styles.fanzoneHeaderImage} src={FanzoneHeader} />
          </div>
        </div>
        <div className={styles.splash}>
          <div className={styles.fanZoneContainer}>
            <div className={styles.fanZoneDesc}>
              For a low monthly subscription, you can get access to special
              content like Videos and Galleries, as well as the ability to watch
              Live Streams, Chat and privately message our Anchors.
            </div>
          </div>
        </div>
        <AnchorFanzone customStyles={styles} fanzones={anchorsWithFanzone} isDiscountPage={false} />
      </Fragment>
    );
  }
}

export default observer(FanZone);
